import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const inputSx = {
  width: 140,
  "& .MuiInputBase-root": { height: 32, fontSize: "0.85rem", borderRadius: 1 },
  "& .MuiInputBase-input": { py: 0.5, px: 1 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    borderColor: "#000 !important",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    borderColor: "#000 !important",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    borderColor: "#000 !important",
  },
};

const RhpLinePriceDialog = ({
  open,
  onClose,
  onApply,
  currentPrice = 0,
}) => {
  const [priceInput, setPriceInput] = useState("0.00");

  useEffect(() => {
    if (!open) {
      return;
    }
    const n = parseFloat(currentPrice);
    setPriceInput(Number.isFinite(n) && n > 0 ? n.toFixed(2) : "0.00");
  }, [open, currentPrice]);

  const handleSubmit = () => {
    const parsed = parseFloat(priceInput);
    if (!Number.isFinite(parsed) || parsed < 0.01 || parsed > 99999.99) {
      return;
    }
    onApply(parsed.toFixed(2));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { width: 280, maxWidth: "95vw" } }}
    >
      <DialogTitle sx={{ py: 1, px: 2, fontSize: "0.95rem" }}>Price</DialogTitle>
      <DialogContent sx={{ pt: 0, px: 2, pb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
          <Typography variant="caption" fontWeight={600} sx={{ flexShrink: 0 }}>
            Price
          </Typography>
          <TextField
            size="small"
            autoFocus
            value={priceInput}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || value === ".") {
                setPriceInput(value);
                return;
              }
              const parsed = parseFloat(value);
              if (!Number.isFinite(parsed) || parsed > 99999.99) {
                return;
              }
              setPriceInput(value);
            }}
            onBlur={() => {
              const parsed = parseFloat(priceInput);
              if (!Number.isFinite(parsed) || parsed < 0.01) {
                const n = parseFloat(currentPrice);
                setPriceInput(Number.isFinite(n) && n > 0 ? n.toFixed(2) : "0.00");
                return;
              }
              setPriceInput(Math.min(99999.99, parsed).toFixed(2));
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit();
              }
            }}
            inputProps={{ inputMode: "decimal", min: 0.01, max: 99999.99 }}
            sx={inputSx}
            InputProps={{
              startAdornment: (
                <Typography variant="caption" sx={{ pl: 0.5, fontSize: "0.7rem" }}>
                  £
                </Typography>
              ),
            }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button variant="contained" size="small" onClick={handleSubmit} sx={{ minWidth: 72 }}>
            Ok
          </Button>
          <Button
            variant="outlined"
            size="small"
            className="button-variant-outlined"
            onClick={onClose}
            sx={{ minWidth: 72 }}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RhpLinePriceDialog;
